import { render, staticRenderFns } from "./shipment-success-icon.vue?vue&type=template&id=ac9b5cf8"
import script from "./shipment-success-icon.vue?vue&type=script&lang=js"
export * from "./shipment-success-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports